//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.SheetMetal.js";
import "../Features/Features.SheetMetal.SheetmetalBaseBuilder.js";
import "../no/Expression.js";
import "../no/Features.js";
let d=[[[1,"Angle",0,"Expression",0],[0,"BaseEdges",1,"ScCollector",0],[0,"BendOptions",0,"Features.SheetMetal.BendOptions",0],[0,"RefFaces",1,"ScCollector",0]],[[["angle_expression"],"SetAngle",{},1,0],[["type","value_expression"],"SetLength",{},2,0],[["type"],"GetLength",{R_:{length_expression:"Expression"}},0,0],[["type","flip_flag"],"SetFlipDirection",{},2,0],[["type"],"GetFlipDirection",{R_:{flip_flag:''}},1,0],[["end_type","comp_type","value_expression"],"SetEndCompensation",{},3,0],[["end_type","comp_type"],"GetEndCompensation",{R_:{value_expression:"Expression"}},1,0],[["end_type","end_plane"],"SetEndPlane",{},2,0],[["end_type"],"GetEndPlane",{R_:{end_plane:"Plane"}},1,0],[["show_contour"],"SetContourFlag",{},1,0],[[],"GetContourFlag",{R_:{show_contour:''}},0,0],[["mat_type"],"SetMaterialType",{},1,0],[[],"GetMaterialType",{R_:{mat_type:''}},0,0],[["dim_type"],"SetDimensionType",{},1,0],[[],"GetDimensionType",{R_:{dim_type:''}},0,0]],[]];
SPLM.Features.SheetMetal.AeroFlangeBuilder = class extends SPLM.Features.SheetMetal.SheetmetalBaseBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.SheetMetal.AeroFlangeBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.SheetMetal.AeroFlangeBuilder.LengthType = Object.freeze({
    "Value" : "Value", "Infer" : "Infer"});

SPLM.Features.SheetMetal.AeroFlangeBuilder.EndType = Object.freeze({
    "End1" : "End1", "End2" : "End2", "Closed" : "Closed"});

SPLM.Features.SheetMetal.AeroFlangeBuilder.DirType = Object.freeze({
    "Bend" : "Bend", "Discard" : "Discard"});

SPLM.Features.SheetMetal.AeroFlangeBuilder.CompType = Object.freeze({
    "Automatic" : "Automatic", "Angle" : "Angle", "Distance" : "Distance", "None" : "None"});

SPLM.Features.SheetMetal.AeroFlangeBuilder.MatType = Object.freeze({
    "MaterialInside" : "MaterialInside", "MaterialOutside" : "MaterialOutside", "BendOutside" : "BendOutside"});

SPLM.Features.SheetMetal.AeroFlangeBuilder.DimType = Object.freeze({
    "Inside" : "Inside", "Outside" : "Outside"});

export default SPLM;